import React from 'react';
import FormField from '../molecules/FormField';
import Input from '../atoms/Input';
import Select from '../atoms/Select';
import RoleMultiSelect from '../molecules/RoleMultiSelect';
import TrashIcon from '../atoms/TrashIcon';

const BOOLEAN_OPTIONS = ['Yes', 'No'];

export default function TableCard({ name, level, value, initialFormValues, setFormValues, onChange, selected = false, onSelect, onDelete, subtitle, roleList = [], showRoleError = false }) {
  const data = value ?? initialFormValues ?? {};
  const role = Array.isArray(data.role) ? data.role : [];
  const roleOptions = roleList.map((role) => ({
    value: role.id ?? role.roleId ?? role.value,
    label: role.name ?? role.label,
  }));
  const updateField = (field, nextValue) => {
    const nextData = { ...data, [field]: nextValue };
    if (setFormValues) {
      setFormValues(nextData);
    } else {
      onChange?.(nextData);
    }
  };
  const accent = level === 1 ? 'green' : level === 2 ? 'orange' : 'blue';
  const fieldId = (field) => `workflow-level-${level}-${field}`;
  const subtitleText =
    subtitle ||
    (level === 1
      ? 'Initial Handler'
      : level === 2
        ? 'Escalation if L1 TAT exceeded'
        : 'Escalation workflow');

  return (
    <article
      className={`ca-table-card ca-table-card--${accent}${selected ? ' ca-table-card--selected' : ''}`}
      onClick={onSelect}
    >
      <header className="ca-table-card__header">
        <span className="ca-table-card__level">L{level}</span>
        <div className="ca-table-card__header-text">
          <h3 className="ca-table-card__title">{name}</h3>
          <p className="ca-table-card__subtitle">{subtitleText}</p>
        </div>
        <button
          type="button"
          className="ca-table-card__delete"
          aria-label={`Delete ${name}`}
          title={`Delete ${name}`}
          onClick={(event) => {
            event.stopPropagation();
            onDelete?.();
          }}
        >
          <TrashIcon size={16} />
        </button>
      </header>
      <div className="ca-table-card__divider" />
      <div className="ca-table-card__fields">
        <FormField label="Select Roles *" htmlFor={fieldId('roleIds')}>
          <RoleMultiSelect
            id={fieldId('role')}
            value={role}
            options={roleOptions}
            placeholder="Select role"
            hasError={showRoleError && role.length === 0}
            onChange={(nextRoleIds) => updateField('role', nextRoleIds)}
          />
        </FormField>

      <div className="ca-table-card__divider" />

        <FormField label="Can Resolve" htmlFor={fieldId('canResolve')}>
          <Select id={fieldId('canResolve')} value={data.canResolve} options={BOOLEAN_OPTIONS} onChange={(event) => updateField('canResolve', event.target.value)} />
        </FormField>
        <FormField label="Can Reassign" htmlFor={fieldId('canReassign')}>
          <Select id={fieldId('canReassign')} value={data.canReassign} options={BOOLEAN_OPTIONS} onChange={(event) => updateField('canReassign', event.target.value)} />
        </FormField>
        <FormField label="Final Level" htmlFor={fieldId('finalLevel')}>
          <Select id={fieldId('finalLevel')} value={data.finalLevel} options={BOOLEAN_OPTIONS} onChange={(event) => updateField('finalLevel', event.target.value)} />
        </FormField>
        <FormField label="Escalation time" htmlFor={fieldId('escalationTime')}>
          <div className="ca-table-card__time-input">
            <Input id={fieldId('escalationTime')} type="text" value={data.escalateAfterMinutes ?? ''} placeholder="--" onChange={(event) => updateField('escalateAfterMinutes', event.target.value)} />
            {/* <span>minutes</span> */}
          </div>
        </FormField>
      </div>
    </article>
  );
}